var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1.36667C1 1.16416 1.16416 1 1.36667 1H22.6333C22.8358 1 23 1.16416 23 1.36667V22.6333C23 22.8358 22.8358 23 22.6333 23H1.36667C1.16416 23 1 22.8358 1 22.6333V1.36667ZM1.73333 1.73333V22.2667H22.2667V1.73333H1.73333Z",
    fill: "#18C60B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10193 1.10739C5.24512 1.25059 5.24512 1.48275 5.10193 1.62594L1.8936 4.83427C1.75041 4.97746 1.51825 4.97746 1.37505 4.83427C1.23186 4.69108 1.23186 4.45892 1.37505 4.31573L4.58339 1.10739C4.72658 0.964202 4.95874 0.964202 5.10193 1.10739Z",
    fill: "#18C60B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7686 1.10739C8.91179 1.25059 8.91179 1.48275 8.7686 1.62594L1.8936 8.50094C1.75041 8.64413 1.51825 8.64413 1.37505 8.50094C1.23186 8.35775 1.23186 8.12559 1.37505 7.98239L8.25005 1.10739C8.39325 0.964202 8.62541 0.964202 8.7686 1.10739Z",
    fill: "#18C60B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4353 1.10739C12.5785 1.25059 12.5785 1.48275 12.4353 1.62594L1.8936 12.1676C1.75041 12.3108 1.51825 12.3108 1.37505 12.1676C1.23186 12.0244 1.23186 11.7923 1.37505 11.6491L11.9167 1.10739C12.0599 0.964202 12.2921 0.964202 12.4353 1.10739Z",
    fill: "#18C60B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1019 1.10739C16.2451 1.25059 16.2451 1.48275 16.1019 1.62594L2.02192 15.7059C1.87873 15.8491 1.64657 15.8491 1.50338 15.7059C1.36019 15.5627 1.36019 15.3306 1.50338 15.1874L15.5834 1.10739C15.7266 0.964202 15.9587 0.964202 16.1019 1.10739Z",
    fill: "#18C60B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7686 1.10739C19.9118 1.25059 19.9118 1.48275 19.7686 1.62594L2.02192 19.3726C1.87873 19.5158 1.64657 19.5158 1.50338 19.3726C1.36019 19.2294 1.36019 18.9973 1.50338 18.8541L19.25 1.10739C19.3932 0.964202 19.6254 0.964202 19.7686 1.10739Z",
    fill: "#18C60B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8926 1.64627C23.0358 1.78945 23.0358 2.02161 22.8926 2.16482L2.35196 22.7091C2.20878 22.8524 1.97662 22.8524 1.83341 22.7092C1.69021 22.566 1.69018 22.3339 1.83336 22.1907L22.374 1.64632C22.5172 1.50311 22.7494 1.50309 22.8926 1.64627Z",
    fill: "#18C60B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8926 5.31293C23.0358 5.45611 23.0358 5.68827 22.8926 5.83148L6.01863 22.7091C5.87545 22.8524 5.64329 22.8524 5.50008 22.7092C5.35687 22.566 5.35685 22.3339 5.50003 22.1907L22.374 5.31299C22.5172 5.16978 22.7494 5.16976 22.8926 5.31293Z",
    fill: "#18C60B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8926 8.97959C23.0358 9.12276 23.0358 9.35492 22.8926 9.49814L9.6853 22.7091C9.54213 22.8523 9.30997 22.8524 9.16676 22.7092C9.02354 22.566 9.02351 22.3339 9.16668 22.1907L22.374 8.97966C22.5172 8.83645 22.7494 8.83642 22.8926 8.97959Z",
    fill: "#18C60B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8925 12.6462C23.0358 12.7894 23.0358 13.0216 22.8926 13.1648L13.352 22.7091C13.2088 22.8523 12.9767 22.8524 12.8334 22.7092C12.6902 22.5661 12.6902 22.3339 12.8333 22.1907L22.374 12.6463C22.5172 12.5031 22.7493 12.5031 22.8925 12.6462Z",
    fill: "#18C60B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8925 16.3129C23.0358 16.456 23.0358 16.6882 22.8927 16.8314L17.0187 22.7091C16.8755 22.8523 16.6434 22.8524 16.5001 22.7093C16.3569 22.5661 16.3568 22.3339 16.5 22.1907L22.374 16.313C22.5171 16.1698 22.7493 16.1697 22.8925 16.3129Z",
    fill: "#18C60B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8924 19.9794C23.0357 20.1225 23.0359 20.3546 22.8928 20.498L20.6855 22.709C20.5424 22.8523 20.3102 22.8525 20.1669 22.7094C20.0236 22.5663 20.0234 22.3342 20.1665 22.1908L22.3738 19.9798C22.5169 19.8365 22.7491 19.8363 22.8924 19.9794Z",
    fill: "#18C60B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGai);
export default __webpack_public_path__ + "static/media/gai.32ab502899f4ed3957f66cac4599d595.svg";
export { ForwardRef as ReactComponent };